<template>
  <BaseUiStyleUserForm />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
